import { useEffect } from 'react';
import { deviceDetect } from 'react-device-detect';
import { useDispatch } from 'react-redux';

import { storeName as appStore } from '../redux/models/app.model';

const useDetectDevice = (): void => {
  const dispatch = useDispatch()[appStore];
  const device = deviceDetect(window.navigator.userAgent);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-syntax
    if (device.isTablet || (device.isBrowser && 'ontouchend' in document)) {
      dispatch.setTabletDevice(true);
      return;
    }

    if (device.isMobile) {
      dispatch.setMobileDevice(true);
    }
  }, [device, dispatch]);
};

export default useDetectDevice;
